import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useProfileFactoryStyles = makeStyles((theme) =>
  createStyles({
    message: {
      display: 'flex',
      marginBottom: 8,

      [theme.breakpoints.down('md')]: {
        marginTop: 32
      },

      [theme.breakpoints.up('xs')]: {
        width: '100%',
        flexDirection: 'column'
      },

      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
        width: 'auto'
      }
    },

    messageInfo: {
      [theme.breakpoints.up('xs')]: {
        marginBottom: 20
      },

      [theme.breakpoints.up('md')]: {
        marginBottom: 0
      }
    },

    messageRequared: {
      marginTop: 16,
      color: '#9E9E9E',
      [theme.breakpoints.up('xs')]: {
        marginBottom: 20
      },

      [theme.breakpoints.up('md')]: {
        marginBottom: 0
      }
    },

    portfolioButton: {
      marginLeft: 'auto',
      marginBottom: 32,

      [theme.breakpoints.up('xs')]: {
        width: '100%'
      },

      [theme.breakpoints.up('md')]: {
        width: 'auto'
      }
    },

    action: {
      display: 'flex',
      justifyContent: 'flex-end'
    },

    deactiveProfileButton: {
      [theme.breakpoints.up('xs')]: {
        width: '100%'
      },

      [theme.breakpoints.up('md')]: {
        width: 'auto'
      }
    }
  })
)
